














import Vue from 'vue';
import * as Constants from '@/constants.ts';
import * as Util from '@/util.ts';

export default Vue.extend({
  data() {
    return {
      locales: Constants.LOCALES,
    };
  },
  computed: {
    currLocale(): string {
      return this.$store.state.locale;
    },
  },
  methods: {
    setTranslationsFor(localeCode: TranslationLocaleCode): void {
      if (this.$store.state.currentClientUser) {
        Util.updateCurrentClientUser({
          settings: {
            ...this.$store.state.currentClientUser.settings,
            locale: localeCode,
          },
        });
      } else {
        this.$store.commit('setLocale', localeCode);
      }
    },
  },
});
